import {
  addCartItem,
  getBannerList,
  getBlogAllListItems,
  getCartFinish,
  getCartInfo,
  getCartRemove,
  getCartSize,
  getCatalogByFilters,
  getCatalogFilterItems,
  getCatalogFilters,
  getCatalogItems,
  getCategories,
  getCategoriesItems,
  getClientList,
  getPageNumberTotal,
  getProductDetailItem,
  getProducts,
  getProductsBestSeller,
  getProductsCategoriesType,
  getProductsHighlighted,
  getProductsMonthly,
  getProductsRecommended,
  getProductsSale,
  getProductsTrending,
  getProductsWithPagination,
  getSearchProducts,
  getSliderList,
  sentContactFormPath,
  sentNewsletterFormPath,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import apiServiceSecond from "../utils/configAxiosSecond";
import { globalActions } from "../reducers/globalActions";
import i18next from "i18next";
import { toast } from "react-toastify";

export const fetchContactFormSent = (
  dataValues,
  showMessageContact,
  navigate
) => {
  return (dispatch) => {
    return apiService
      .post(sentContactFormPath(), dataValues)
      .then((response) => {
        showMessageContact();
      })
      .catch((err) => {
        navigate("", { replace: true });
        console.log(err, "err");
      });
  };
};

export const fetchNewsletterFormSent = (dataValues, showMessageContact) => {
  return (dispatch) => {
    return apiService
      .post(sentNewsletterFormPath(), dataValues)
      .then((response) => {
        showMessageContact();
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchBlogListItems = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(getBlogAllListItems(i18next.language, id))
      .then((response) => {
        dispatch(globalActions.fetchItemsListBlogAll(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCategoriesList = () => {
  return (dispatch) => {
    return apiServiceSecond
      .get(getCategoriesItems())
      .then((response) => {
        dispatch(globalActions.fetchItemsCategoriesAll(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchProductsHomeCategoryAll1 = (filters, categoryId, attr) => {
  return (dispatch) => {
    return apiServiceSecond
      .get(getCatalogByFilters(filters, categoryId, attr))
      .then((response) => {
        dispatch(globalActions.fetchProductsAll1(response?.data?.content));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchProductsHomeCategoryAll2 = (filters, categoryId, attr) => {
  return (dispatch) => {
    return apiServiceSecond
      .get(getCatalogByFilters(filters, categoryId, attr))
      .then((response) => {
        dispatch(globalActions.fetchProductsAll2(response?.data?.content));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchRelatedProductsAll = (filters, categoryId, attr) => {
  return (dispatch) => {
    return apiServiceSecond
      .get(getCatalogByFilters(filters, categoryId, attr))
      .then((response) => {
        dispatch(
          globalActions.fetchRelatedProductsAll(response?.data?.content)
        );
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchProductsDetail = (dataValue) => {
  return (dispatch) => {
    dispatch(globalActions.actionStartProductDetail());
    return apiService
      .post(getProducts(), dataValue)
      .then((response) => {
        dispatch(globalActions.fetchDetailProduct(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchProductsAllWithPagination = (dataValue) => {
  return (dispatch) => {
    dispatch(globalActions.actionStartCatalog2());
    return apiService
      .post(getProductsWithPagination(), dataValue)
      .then((response) => {
        dispatch(globalActions.actionStartCatalogClear());
        dispatch(globalActions.fetchProductsAll(response.data.items));
        // dispatch(globalActions.dataCatalogFilters(response.data.filters));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchSearchProductsAll = (dataValue) => {
  return (dispatch) => {
    dispatch(globalActions.actionStartSearch());
    return apiServiceSecond
      .get(getSearchProducts(dataValue))
      .then((response) => {
        dispatch(globalActions.dataSearchProductsList(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCilentsList = () => {
  return (dispatch) => {
    return apiService
      .get(getClientList())
      .then((response) => {
        dispatch(globalActions.dataClientList(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchSlidersList = () => {
  return (dispatch) => {
    return apiService
      .get(getSliderList())
      .then((response) => {
        dispatch(globalActions.dataSliderList(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchBannersList = () => {
  return (dispatch) => {
    return apiService
      .get(getBannerList())
      .then((response) => {
        dispatch(globalActions.dataBannerList(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchPageNumberTotal = (dataValue) => {
  return (dispatch) => {
    return apiService
      .post(getPageNumberTotal(), dataValue)
      .then((response) => {
        dispatch(globalActions.dataCatalogPagination(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCatalogFilters = (dataValue) => {
  return (dispatch) => {
    dispatch(globalActions.actionStartCatalogFilter());
    return apiService
      .post(getCatalogFilters(), dataValue)
      .then((response) => {
        dispatch(globalActions.actionStartCatalogFilterClear());
        dispatch(globalActions.dataCatalogFilters(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchProductsCategoriesTypeAllOLD = (type) => {
  return (dispatch) => {
    return apiService
      .get(getProductsCategoriesType(type))
      .then((response) => {
        if (type === "mesecnaAkcija") {
          dispatch(globalActions.fetchProductsMesecnaAkcija(response.data));
        } else if (type === "popularno") {
          dispatch(globalActions.fetchProductsPopularno(response.data));
        } else if (type === "izdvajamo") {
          dispatch(globalActions.fetchProductsIzdvajamoIzPonude(response.data));
        } else if (type === "preporucujemo") {
          dispatch(globalActions.fetchProductsPreporucujemo(response.data));
        } else if (type === "specijalnaAkcija") {
          dispatch(globalActions.fetchProductsSpecijalnaAkcija(response.data));
        } else if (type === "ponovoNaStanju") {
          dispatch(globalActions.fetchProductsPonovoNaStanju(response.data));
        }
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCatalogItems = (dataValue) => {
  return (dispatch) => {
    return apiServiceSecond
      .get(getCatalogItems(), dataValue)
      .then((response) => {
        // dispatch(globalActions.dataCatalogPagination(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCatalogItemFilters = (categoryId) => {
  return (dispatch) => {
    return apiServiceSecond
      .get(getCatalogFilterItems(categoryId))
      .then((response) => {
        dispatch(globalActions.dataCatalogFilters(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

// mapiranje tipova na rutu i dispatch akciju
const productTypeMap = {
  monthlySale: {
    url: getProductsMonthly(),
    action: (data) => globalActions.fetchProductsMesecnaAkcija(data),
  },
  popularno: {
    url: getProductsTrending(),
    action: (data) => globalActions.fetchProductsPopularno(data),
  },
  izdvajamo: {
    url: getProductsHighlighted(),
    action: (data) => globalActions.fetchProductsIzdvajamoIzPonude(data),
  },
  preporucujemo: {
    url: getProductsRecommended(),
    action: (data) => globalActions.fetchProductsPreporucujemo(data),
  },
  specijalnaAkcija: {
    url: getProductsSale(),
    action: (data) => globalActions.fetchProductsSpecijalnaAkcija(data),
  },
  ponovoNaStanju: {
    url: getProductsBestSeller(),
    action: (data) => globalActions.fetchProductsPonovoNaStanju(data),
  },
};

export const fetchProductsCategoriesTypeAll = (type) => {
  return (dispatch) => {
    const config = productTypeMap[type];
    if (!config) {
      console.warn(`Nepoznat tip: ${type}`);
      return;
    }

    return apiServiceSecond
      .get(config.url)
      .then((response) => {
        dispatch(config.action(response.data));
      })
      .catch((err) => {
        console.error(err, "err");
      });
  };
};

export const fetchProductsByFilters = (filters, categoryId, attr) => {
  return (dispatch) => {
    return apiServiceSecond
      .get(getCatalogByFilters(filters, categoryId, attr))
      .then((response) => {
        dispatch(globalActions.fetchProductsAll(response.data.content));
        dispatch(globalActions.dataCatalogPagination(response.data.page));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchProductDetailItem = (id) => {
  return (dispatch) => {
    dispatch(globalActions.actionStartProductDetail());
    return apiServiceSecond
      .get(getProductDetailItem(id))
      .then((response) => {
        dispatch(globalActions.fetchDetailProduct(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchAddToCartItem = (data) => {
  return (dispatch) => {
    dispatch(globalActions.actionStart());
    return apiServiceSecond
      .post(addCartItem(), data)
      .then((response) => {
        toast.success("Uspesno ste dodali proizvod u korpu", {
          theme: "colored",
        });
        dispatch(fetchCartCount());
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCartItems = () => {
  return (dispatch) => {
    dispatch(globalActions.actionStart());
    return apiServiceSecond
      .get(getCartInfo())
      .then((response) => {
        dispatch(globalActions.fetchCartItems(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchRemoveToCartItem = (data) => {
  return (dispatch) => {
    dispatch(globalActions.actionStart());
    return apiServiceSecond
      .post(getCartRemove(), data)
      .then((response) => {
        toast.success("Uspesno ste obrisali proizvod iz korpe", {
          theme: "colored",
        });
        dispatch(fetchCartItems());
        dispatch(fetchCartCount());
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCartCount = () => {
  return (dispatch) => {
    dispatch(globalActions.actionStart());
    return apiServiceSecond
      .get(getCartSize())
      .then((response) => {
        dispatch(globalActions.fetchCartCount(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCartFinish = (data, navigate, resetCaptcha) => {
  return (dispatch) => {
    dispatch(globalActions.actionStart());
    return apiServiceSecond
      .post(getCartFinish(), data)
      .then((response) => {
        dispatch(fetchCartCount());
        resetCaptcha();
        navigate("/success-page");
      })
      .catch((err) => {
        toast.error(
          "Doslo je do greske, molimo pokusajte kasnije ili kontaktirajte nas",
          {
            theme: "colored",
          }
        );
      });
  };
};
